export default {
    listagem: {
        titulo_pagina: 'Review Results',
        table: {
            recipiente: 'Container',
            informacoes: 'Information',
            paciente: 'Patient',
            exames: 'Exams',
            vns: 'VNS',
            empresa: 'Company',
            usuario_edicao: 'Editing User',
            ultima_atualizacao: 'Last Update',
            acoes: 'Actions'
        },
        confirmacao_cancelamento: {
            titulo: 'Cancelation',
            mensagem: 'Are you sure you want to cancel the results of this review? This action cannot be undone.'
        }
    },
    form: {
        titulo_pagina: 'Edit Results Under Review',
        sem_resultados: 'No more results to review.',
        outro_usuario: 'This result is being edited by another user.',
        fieldsets: {
            informacoes: 'Information',
            exames: 'Exams'
        },
        fields: {
            recipiente: {
                label: 'Container'              
            },
            paciente: {
                label: 'Patient'
            },
            vns: {
                label: 'VNS',
            },
            empresa: {
                label: 'Company',
            },
            ultima_atualizacao: {
                label: 'Last Update'
            },
            exame: {
                label: 'Exam'                
            },
            exame_ordem: {
                label: 'Order Exam'
            },
            material: {
                label: 'Material'
            },
            resultado: {
                label: 'Result'
            },
            unidade_medida: {
                label: 'Unit of Measure'
            },
            erro_mapeamento: {
                label: 'Mapping Error',
                mensagem: 'Some fields of this exam were not mapped correctly.'
            },
            edit:{
                resultado: {
                    label: 'New Result',
                    description: 'Enter the new result for the exam.'
                },
                unidade_medida: {
                    label: 'New Unit of Measure',
                    description: 'Enter the new unit of measure for the exam.'
                },
                motivo: {
                    label: 'Reason',
                    description: 'Explain the reason for the change.'
                }
            },
            cancelar_resultados: 'Cancel Results',
            botao_salvar: 'Save Result and Submit',
            botao_salvar_proximo: 'Save Result, Submit and Go to Next',
        },
        update: {
            success: 'Result successfully edited!',
            error: 'Error editing the result!',
            warning: 'The result has been sent to the source system.'
        },
        cancel: {
            success: 'Results canceled successfully!',
            error: 'Error canceling the results!'
        },
        list: {
            error: 'An error occurred while trying to load the screen data!'
        },
        validation: {
            motivo_required: 'The reason is required.',
            motivo_maxlength: 'The reason cannot exceed 500 characters.',
            resultado_required: 'The result is required.',
            resultado_maxlength: 'The result cannot exceed 255 characters.',
            unidade_medida_required: 'The unit of measure is required.',
            unidade_medida_maxlength: 'The unit of measure cannot exceed 255 characters.'
        }
    }
}
